import { useContext } from 'react';
import { createContext } from 'react';

import { TabListItemProps } from '../@types/TabListItemProps';

export const TabListItemContext = createContext<TabListItemProps>({} as TabListItemProps);

TabListItemContext.displayName = 'TabListItem';

const TabListItemProvider = (props: TabListItemProps) => (
	<TabListItemContext.Provider value={props}>{props.children}</TabListItemContext.Provider>
);

export const useTabListItem = () => {
	const context = useContext(TabListItemContext);

	return context;
};

export default TabListItemProvider;
